<template>
  <v-container fluid px-3>
    <v-layout row wrap>
      <v-flex xs12 v-show="isCollection && !isRecord">
        <v-card>
          <v-card-title primary-title>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="headline blue--text">Itens do serviços</div>
                </v-flex>
                <v-flex xs12>
                  <v-btn block color="blue darken-2" dark v-on:click="showForm()">Adicionar Item</v-btn> 
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr v-on:click="showForm(props.item)" class="pointer">
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td class="text-xs-right">{{ props.item.quantity }}</td>
                <td class="text-xs-right">R$ {{ props.item.value.split('$').join('') }}</td>
                <td class="text-xs-right">R$ {{ calculateTotal(props.item.value, props.item.quantity) }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="isRecord">
        <OrderItemForm v-bind:record="selectedRecord" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderItemForm from "./OrderItemForm";
import pathToRegexp from 'path-to-regexp'
import utils from '../../shared/Utils'

export default {
  name: "OrderItemList",
  components: { OrderItemForm },
  data () {
    return {
      headers: [
        { text: 'Descrição', align: 'left', value: 'description' },
        { text: 'Quant', value: 'quantity', align: 'right' },
        { text: 'Valor', value: 'value', align: 'right' },
        { text: 'Total', value: 'value', align: 'right' },
      ],
      items: [],
      selected_item: {},
      loading: false
    }
  },
  mounted() {
    this.loadRecordsIfNeeded()
  },
  computed: {
    selectedRecord() {
      return this.selected_item
    },
    isCollection() {
      return this.checkRoute('/cliente/:id/servico/:order_id*');
    },
    isRecord() {
      return this.checkRoute('/cliente/:id/servico/:order_id/:item_id');
    },
    orderId() {
      const check = pathToRegexp('/cliente/:id/servico/:order_id*').exec(this.$route.path)
      return check === null ? null : (check[2] == 'novo' ? null : check[2])
    },
    isNewRecord() {
      return this.checkRoute('/cliente/:id/servico/:order_id/item/novo');
    }
  },
  methods: {
    calculateTotal(value, quantity) {
      const int_quantity = parseInt(quantity)
      const int_cents    = parseInt(value.split('$').join('').split('.').join(''))
      return utils.centsToMoney(int_quantity * int_cents)
    },
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    showForm(order_item) {
      let order_item_id
      if (typeof(order_item) === 'undefined') {
        order_item_id = 'novo'
        this.selected_item = { id: null, description: '', quantity: '1', value: '', notes: '' }
      } else {
        this.selected_item = order_item
        order_item_id = order_item.id
      }
      this.$router.push({ path: `${this.$route.path}/${order_item_id}` })
    },
    loadRecordsIfNeeded() {
      if (this.isCollection && !this.isRecord) {
        this.loading = true

        let successCallback = (response) => {
          if (response.body.data) {
            this.loading = false
            this.items = response.body.data
          }
        }

        let errorCallback = (response) => {
          debugger
        }

        this.$http.get(`${this.$root.base_url}/orders/${this.orderId}/orders_items`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.loadRecordsIfNeeded()
    }
  }
};
</script>

<style>
 .pointer {
   cursor: pointer;
 }
</style>



// WEBPACK FOOTER //
// src/components/mecanica/OrderItemList.vue